export default "__VITE_ASSET__5745be9e__"